/***Dependencies */
import React from "react";

/**Components */
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

/**Styles */

import { Col, Row } from "react-bootstrap";
import { Currency, FormatDate } from "../helpers";

/**
 * Componente principal que muestra el banner con carrusel, inputs de búsqueda y selector de habitaciones.
 * @param {array} imgsBanner - Arreglo de objetos con propiedades "image" que contienen la ruta de
 *                              las imágenes del carrusel.
 * @param {boolean} showSearch - Indica si se muestra el formulario de búsqueda o no.
 * @returns {React.Component} - Componente principal con el banner y los inputs de búsqueda.
 */
export const ReservaConfirmada = ({
  arrReserva,
  reserva,
  arrReservaInfo,
  totalReservaHotelera,
}) => {
  return (
    <>
      <Row className="justify-content-center">
        <Col lg={12} className="d-flex justify-content-center">
          <img
            src="https://panel.internationaltravelnet.com.mx/assets/img/Logo.png"
            alt=""
          />
        </Col>
        <Col lg={12}>
          <h1 className="text-center">
            Reservacion Confirmada <br />{" "}
            <span style={{ fontSize: "30px" }}>
              Clave de confirmación: ITN-{reserva?.idReserva}{" "}
            </span>
          </h1>
        </Col>
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #d80100",
          }}
          className=""
        />
        <Col lg={12} className="mt-3 text-center">
          <h4 style={{ fontSize: "25px" }}>Datos del Hotel</h4>
          <Row className="justify-content-center">
            <Col
              style={{ borderRight: "1px solid black", textAlign: "end" }}
              lg={6}
              md={6}
              xs={6}
            >
              <p style={{ fontSize: "17px" }}>Hotel</p>
              <p style={{ fontSize: "17px" }}>Categoría</p>
              <p style={{ fontSize: "17px" }}>Dirección</p>
            </Col>
            <Col lg={6} md={6} xs={6} className="text-start">
              <p style={{ fontSize: "17px" }}>
                {reserva?.reservaHoteleria?.hotel}
              </p>
              <p style={{ fontSize: "17px" }}>
                {arrReservaInfo?.habitaciones_reserva?.[0]?.categoria}
              </p>
              <p style={{ fontSize: "17px" }}>
                {arrReservaInfo?.hotel?.direccion}
              </p>
            </Col>
          </Row>
        </Col>
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #d80100",
          }}
          className="my-3"
        />
        <Col lg={12} className="mt-3 text-center">
          <h4 style={{ fontSize: "25px" }}>Datos de reservación hotelera</h4>
          <Row className="justify-content-center">
            <Col
              style={{ borderRight: "1px solid black", textAlign: "end" }}
              lg={6}
              md={6}
              xs={6}
            >
              <p style={{ fontSize: "17px" }}>Titular de reservación</p>
              <p style={{ fontSize: "17px" }}>Número de reservación</p>
              <p style={{ fontSize: "17px" }}>Total Pago</p>
            </Col>
            <Col lg={6} md={6} xs={6} className="text-start">
              <p style={{ fontSize: "17px" }}>
                {arrReservaInfo?.hotel_reserva?.apellido_titular}
              </p>
              <p style={{ fontSize: "17px" }}>
                {arrReservaInfo?.habitaciones_reserva?.[0]?.id_res_api}
              </p>
              <p style={{ fontSize: "17px" }}>
                {Currency(reserva?.totalPago) + " MXN"}
              </p>
            </Col>
          </Row>
        </Col>
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #d80100",
          }}
          className="my-3"
        />
        {arrReservaInfo.habitaciones_reserva?.map((reserva, index) => (
          <>
            <Col lg={12} key={index + 1} className="mt-3 text-center">
              <h4 style={{ fontSize: "25px" }}>
                Datos de habitación {index + 1}
              </h4>
              <Row className="justify-content-center">
                <Col
                  style={{ borderRight: "1px solid black", textAlign: "end" }}
                  lg={6}
                  md={6}
                  xs={6}
                >
                  <p style={{ fontSize: "17px" }}>Responsable de habitación</p>
                  <p style={{ fontSize: "17px" }}>Adultos</p>
                  <p style={{ fontSize: "17px" }}>Niños</p>
                  <p style={{ fontSize: "17px" }}>Tipo de habitación</p>
                  <p style={{ fontSize: "17px" }}>Tipo de habitación</p>
                  <p style={{ fontSize: "17px" }}>Fecha reservada</p>
                </Col>
                <Col lg={6} md={6} xs={6} className="text-start">
                  <p style={{ fontSize: "17px" }}>
                    {reserva?.nombre_responsable}{" "}
                    {reserva?.apellido_responsable}
                  </p>
                  <p style={{ fontSize: "17px" }}>{reserva?.num_adultos}</p>
                  <p style={{ fontSize: "17px" }}>{reserva?.num_menores}</p>
                  <p style={{ fontSize: "17px" }}>{reserva?.alojamiento}</p>
                  <p style={{ fontSize: "17px" }}>{reserva?.plan_alimentos}</p>
                  <p style={{ fontSize: "17px" }}>
                    Del {FormatDate(reserva?.checkin)} al{" "}
                    {FormatDate(reserva?.checkout)}
                  </p>
                </Col>
              </Row>
            </Col>
            <Col lg={12}>
              <p
                dangerouslySetInnerHTML={{
                  __html: arrReserva?.find(
                    (id) => id?.nombreHab == reserva?.alojamiento
                  )?.cancellationPoliciesText,
                }}
                style={{ fontSize: "17px" }}
              />
              <p style={{ fontSize: "17px" }}>Información importante</p>
              <p style={{ fontSize: "17px" }}>
                {
                  arrReserva?.find(
                    (id) => id?.nombreHab == reserva?.alojamiento
                  )?.comentario
                }
              </p>
            </Col>
          </>
        ))}
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #d80100",
          }}
          className="my-3"
        />
        <Col lg={12} className="mt-3 text-center">
          <h4>Total de la reserva</h4>
          <Row className="justify-content-center">
            <Col
              style={{ borderRight: "1px solid black", textAlign: "end" }}
              lg={6}
              md={6}
              xs={6}
            >
              <p style={{ fontSize: "17px" }}>Subtotal</p>
              <p style={{ fontSize: "17px" }}>Impuestos</p>
              <p style={{ fontSize: "17px" }}>Total con Impuestos</p>
            </Col>
            <Col lg={6} md={6} xs={6} className="text-start">
              <p style={{ fontSize: "17px" }}>
                {Currency(totalReservaHotelera?.subtotal) + " MXN"}
              </p>
              <p style={{ fontSize: "17px" }}>
                {Currency(totalReservaHotelera?.impuesto) + " MXN"}
              </p>
              <p style={{ fontSize: "17px" }}>
                {Currency(totalReservaHotelera?.total) + " MXN"}
              </p>
            </Col>
          </Row>
        </Col>
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #d80100",
          }}
          className="my-3"
        />
        <Col lg={12}>
          <p style={{ textAlign: "justify", fontSize: "17px" }}>
            No olvides presentar este correo junto con la identificación (INE,
            pasaporte) en el momento de ingreso a tu hotel.
          </p>

          <p style={{ textAlign: "justify", fontSize: "17px" }}>
            Información importante
            <br />
            Este correo electrónico es tu comprobante de pago o transacción
            bancaria. No es válido para el uso del servicio, recibirás por
            correo electrónico tu cupón o itinerario en un próximo correo
            electrónico. No dudes en ponerte en contacto ante cualquier duda o
            aclaración.
          </p>
          <p style={{ textAlign: "justify", fontSize: "17px" }}>
            En International Travel Net estamos comprometidos con tu seguridad.
            Por ello, te informamos que de manera aleatoria nuestro Departamento
            de Protección de Datos Personales, realiza una validación adicional
            y podrá solicitar documentos que comprueben que eres el titular de
            la reserva y/o la compra es autorizada por el titular de la forma de
            pago que elegiste. En caso de no proveerla, tu reserva puede estar
            sujeta a la cancelación.
            <br />
            <br />
            Si tienes dudas de tu reservación o deseas realizar algún cambio,
            comunícate al 777 203 50 97 y uno de nuestros ejecutivos te podrá
            asesorar.
            <br />
            <br />
            Después de realizar tu pago deberás confirmarlo enviándolo al correo
            contacto@tranet.com.mx si no se confirma el pago en las siguientes
            24 horas deberá confirmar que la habitación está disponible
            generando nuevamente tu reservación.
          </p>
          <p style={{ textAlign: "justify", fontSize: "17px" }}>
            Para solicitar tu factura, favor de contactarnos
            <br />
            <br />
            777 203 50 97 | contacto@tranet.com.mx
          </p>
          <p style={{ textAlign: "center", fontSize: "17px" }}>
            © International Travel Net. Todos los derechos reservados.
          </p>
        </Col>
      </Row>
    </>
  );
};
